
export const promotionType = {
    Price: "price",
    Percent: "percent",
    Group: "group",
}